import React from 'react';
import { Flex, Spinner } from '@skin-seoul/design-system';
const CART_LOADING_INDICATOR_TEST_ID = 'cart-loading-indicator';

const CartLoaderBackdrop = () => {
  return (
    <Flex
      position="absolute"
      height="100vh"
      width="100%"
      top={0}
      left={0}
      backdropFilter="blur(1px)"
      backgroundColor="rgba(0, 0, 0, 0.2)"
      zIndex="banner"
      alignItems="center"
      justifyContent="center"
      data-testid={CART_LOADING_INDICATOR_TEST_ID}
    >
      <Spinner color="primary.600" size="xl" animationDuration="0.8s" />
    </Flex>
  );
};

export default CartLoaderBackdrop;
